import { useWorkOrderItemTags } from '@/core/domain/workorder/WorkOrderItemTags/WorkOrderItemTags.hooks';
import { useDebounce, useDisclosure } from '@/hooks';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { Badge, Button, Select, SelectProps } from 'antd';
import { useState } from 'react';
import Group from '../Group';
import CreateCompanyWorkorderItemTagModal from '@/components/Companies/Settings/CreateCompanyWorkorderItemTagModal';
import { useWorkorderDetailContext } from '@/components/Movements/WorkOrders/Details/WorkorderDetailProvider';

type Props = {
  companyId?: number;
} & SelectProps;

const TagSelect: React.FC<Props> = ({ companyId, ...props }) => {
  const { workorder } = useWorkorderDetailContext();
  const [searchValue, setSearchValue] = useState<string>();
  const search = useDebounce(searchValue);

  const [createTagModalOpened, createTagModalAction] = useDisclosure();

  const { data, isLoading } = useWorkOrderItemTags({
    companyId,
    search,
    showDeleted: false,
  });
  const tags = flatInfiniteData(data);

  return (
    <>
      <Select
        {...props}
        loading={isLoading}
        showSearch
        searchValue={searchValue}
        onSearch={setSearchValue}
        allowClear
        dropdownRender={(menu) => (
          <>
            {menu}

            <Button block type="link" onClick={createTagModalAction.open}>
              Adicionar Tag
            </Button>
          </>
        )}
      >
        {tags.map((item) => (
          <Select.Option value={item.id} key={item.id}>
            <Group>
              <Badge color={item.color} /> {item.description}
            </Group>
          </Select.Option>
        ))}
      </Select>

      <CreateCompanyWorkorderItemTagModal
        visible={createTagModalOpened}
        handleVisible={createTagModalAction.close}
        companyId={workorder.data?.company.id}
      />
    </>
  );
};

export default TagSelect;
